<p>
  ui-sidebar-right works!
</p>
